import {
  CartItemTypes,
  ICartItem_Slot,
  IGetCart,
} from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import { Col, Row } from "@/utils/bootstrap";
import ItemRemoveBtn from "./cart-item-btns/item-romove-btn/ItemRemoveBtn";
import Price from "@/app/components/lib/Price";
import CartItemImg from "./CartItemImg";
import ItemQuantityBtn from "./cart-item-btns/item-quantity-btn/ItemQuantityBtn";
import { useEffect, useState } from "react";
import { debounce } from "../../cart-functions";
import useEventTrackers from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/useEventTrackers";
import { EventType } from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/helpers/interfaces";
import { ApiMsgTypes } from "@/api/AppApi/common-interfaces/IResultStamp";
import { useManageCartItem } from "@/api/AppApi/services/cart";
import { currencyAtom } from "@/hooks/currencyAtom";
import { useAtom } from "jotai";
import NotFieldErrModal from "@/app/components/common-form-builder/form-builder-helpers/NotFieldErrModal";
import { v4 as uuidv4 } from "uuid";

interface Props {
  cartItem: ICartItem_Slot;
}

const CartItemSlot: React.FC<Props> = ({ cartItem }) => {
  const FBEventID = uuidv4();
  const { eventTrackers } = useEventTrackers();

  const [resultMsg, setResultMsg] = useState();
  const [currency] = useAtom(currencyAtom);
  const [quantity, setQuantity] = useState(0);

  const manageCartApi = useManageCartItem({
    onSuccess: (res: IGetCart) => {
      const { coupon } = res.result ?? {};
      if (res?.message?.type === ApiMsgTypes.success) {
        eventTrackers(EventType.ADD_CART, [{ ...cartItem }], {
          currency: currency?.code,
          value: cartItem?.price,
          coupon: coupon?.code ?? "",
          discount: cartItem?.discount,
        }, {}, FBEventID);
      }
    },
    onError: (error) => {
      setResultMsg(error.response.data.message.text ?? error.message.text);
      setQuantity(cartItem?.quantity ?? 0);
      // console.log(error.response.data.message.text);
      // console.log(error);
    },
  });
  const handleQuantityChange = (qty: number) => {
    setQuantity(qty);
    debounce(
      manageCartApi.mutate({
        cartId: cartItem.id,
        type: CartItemTypes.slot,
        id: cartItem?.inner_id,
        quantity: qty,
        date: cartItem.others.date,
        addons: cartItem.addons,
        note: cartItem.note,
        other_inputs: cartItem.others.data_fields,
        product_id: null,
        event_id: FBEventID,
      }),
      300,
    );
  };

  useEffect(() => {
    setQuantity(cartItem.quantity);
  }, [cartItem.quantity, resultMsg]);
  return (
    <>
      <Row className="m-0 cart-item">
        <CartItemImg
          discount={cartItem.discount}
          image_url={cartItem?.thumbnail_url}
          is_new={false}
          discount_amount={0}
          has_discount={false}
          discount_type={undefined}
        />
        <Col className="p-0">
          <h3 className="name m-0">{cartItem?.name}</h3>
          <p className="date-time m-0">{cartItem?.others.date}</p>
          <Row className="m-0 align-items-end">
            <Col className="p-0">
              <div className="date-time">
                <bdi>{cartItem?.others?.start_at}</bdi>
                {" - "}
                <bdi>{cartItem?.others?.end_at}</bdi>
              </div>
              <div className="price-line">
                <Price price={{ value: cartItem?.price, className: "price" }} />
              </div>
            </Col>
            {cartItem?.can_edit ? (
              <Col className="p-0 col-auto">
                <ItemQuantityBtn
                  cartItemId={cartItem?.id}
                  quantity={quantity}
                  setQuantity={handleQuantityChange}
                  plusDisabled={false}
                  min_quantity_in_cart={1}
                />
              </Col>
            ) : (
              <Col className="p-0 col-auto">
                <ItemRemoveBtn cartItemId={cartItem.id} />
              </Col>
            )}
          </Row>
        </Col>
      </Row>
      {resultMsg && (
        <NotFieldErrModal
          errors={[resultMsg]}
          setErrors={() => setResultMsg(undefined)}
        />
      )}
    </>
  );
};

export default CartItemSlot;
